import React, { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {useDispatch} from "react-redux";

import { useInitialize } from "../../../util/react.js";
import {ScreenLoading} from "../../../components/screen.js";
import {initialize} from "./actions.js";

export default function B2C_ConfirmSignUpEntry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const rentContract = searchParams.get('rentContract');

  const init = useCallback(async () => {
    const nextPath = await dispatch(initialize(token, rentContract));
    if (nextPath && nextPath.length > 0) {
      navigate(nextPath);
    }
  }, [dispatch, navigate, rentContract, token]);
  
  useInitialize(init);

  return <ScreenLoading />;
}
